import { themeifyStyle } from '../../themes/utilities';

export const disabled = themeifyStyle((theme) => ({
  color: theme.palette.neutral250,
}));
